(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cannabox-welcome"] && !Shopify.designMode) return;
  try {
    (() => {
    const dialog = document.getElementById('CannaboxWelcome');
    if (!dialog || window.Shopify?.designMode) return;
    try {
      if (localStorage.getItem('cannabox-welcome-seen')) return;
    } catch { return; }
    dialog.addEventListener('close', () => {
      try { localStorage.setItem('cannabox-welcome-seen', '1'); } catch {}
    });
    dialog.querySelector('a').addEventListener('click', () => dialog.close());
    window.addEventListener('load', () => {
      if (document.querySelector('dialog[open]')) return;
      dialog.showModal();
    }, { once: true });
  })();
  } catch(e) { console.error(e); }
})();

})();
